<template>
  <b-navbar toggleable="xs">

    <b-button id="open-close-sidebar" v-b-toggle="'sidebar-collapse'" variant="blue-soft" pill>
      <i class="fa fa-bars"/>
    </b-button>

    <b-navbar-brand :to="{name: 'Home'}" class="m-0 p-0">
      <img src="/static/img/logo.png"/>
    </b-navbar-brand>

    <b-nav>
      <b-nav-item-dropdown right>
        <!-- Using 'button-content' slot -->
        <template v-slot:button-content>
          <em v-if="nameUser">{{ nameUser.split(' ')[0] }}</em>
          <img v-else class="img-profile rounded-circle" src="/static/img/perfil.png"/>
        </template>
        <b-dropdown-item @click="logout()">
          <i class="fas fa-sign-out-alt mr-2"></i>Sair
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-nav>
  </b-navbar>
</template>

<script>
import Cookies from 'js-cookie'
import {VS_URL, SUB_DOMAIN} from '@/providers/EnvironmentProvider'

export default {
  name: 'TopBar',
  data() {
    return {
      nameUser: ''
    }
  },
  mounted() {
    this.nameUser = Cookies.get('veus_nm_usuario')
  },
  methods: {
    logout() {
      Cookies.remove('vws_token', {path: '/', domain: SUB_DOMAIN})
      Cookies.remove('veus_nm_usuario', {path: '/', domain: SUB_DOMAIN})
      Cookies.remove('veus_usuario_id', {path: '/', domain: SUB_DOMAIN})
      Cookies.remove('vws_veus_company_id', {path: '/', domain: SUB_DOMAIN})
      window.location = VS_URL
    }
  }
}
</script>

<style lang="scss" scoped>
.img-profile {
  width: 2em;
  height: 2em;
}
/deep/.navbar-brand{
  display: none;
  @media only screen and (min-width: 990px) {
    display: block !important;
  }
}
</style>
